export const AG_GRID_LOCALE_RO = {
  // Set Filter
  selectAll: '(Selectează tot)',
  selectAllSearchResults: '(Selectează toate rezultatele căutării)',
  addCurrentSelectionToFilter: 'Adaugă selecția curentă la filtru',
  searchOoo: 'Căutare...',
  blanks: '(Goluri)',
  noMatches: 'Fără potriviri',
  typeToSearchOoo: 'Tastează pentru a căuta...',

  // Number Filter & Text Filter
  filterOoo: 'Filtrează...',
  equals: 'Egal',
  notEqual: 'Nu este egal',
  blank: 'Gol',
  notBlank: 'Nu este gol',
  empty: 'Alege una',

  // Number Filter
  lessThan: 'Mai puțin decât',
  greaterThan: 'Mai mult decât',
  lessThanOrEqual: 'Mai puțin sau egal cu',
  greaterThanOrEqual: 'Mai mult sau egal cu',
  inRange: 'Între',
  inRangeStart: 'De la',
  inRangeEnd: 'Până la',

  // Text Filter
  contains: 'Conține',
  notContains: 'Nu conține',
  startsWith: 'Începe cu',
  endsWith: 'Se termină cu',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',
  before: 'Înainte',
  after: 'După',
  yesterday: 'Ieri',
  today: 'Astăzi',
  tomorrow: 'Mâine',
  last7Days: 'Ultimele 7 zile',
  lastWeek: 'Săptămâna trecută',
  thisWeek: 'Această săptămână',
  nextWeek: 'Săptămâna viitoare',
  last30Days: 'Ultimele 30 de zile',
  lastMonth: 'Luna trecută',
  thisMonth: 'Această lună',
  nextMonth: 'Luna viitoare',
  last90Days: 'Ultimele 90 de zile',
  lastQuarter: 'Trimestrul trecut',
  thisQuarter: 'Acest trimestru',
  nextQuarter: 'Trimestrul viitor',
  lastYear: 'Anul trecut',
  thisYear: 'Acest an',
  yearToDate: 'De la începutul anului până în prezent',
  nextYear: 'Anul viitor',
  last6Months: 'Ultimele 6 luni',
  last12Months: 'Ultimele 12 luni',
  last24Months: 'Ultimele 24 de luni',

  // Filter Conditions
  andCondition: 'ȘI',
  orCondition: 'SAU',

  // Filter Buttons
  applyFilter: 'Aplică',
  applyColumnToolPanel: 'Aplică',
  resetFilter: 'Resetează',
  clearFilter: 'Curăță',
  cancelFilter: 'Anulează',
  cancelColumnToolPanel: 'Anulează',

  // Filter Titles
  textFilter: 'Filtru text',
  numberFilter: 'Filtru număr',
  dateFilter: 'Filtru dată',
  setFilter: 'Filtru set',

  // Group Column Filter
  groupFilterSelect: 'Selectează câmp:',

  // New Filter Tool Panel
  filterSummaryInactive: 'este (Toate)',
  filterSummaryContains: 'conține',
  filterSummaryNotContains: 'nu conține',
  filterSummaryTextEquals: 'este egal cu',
  filterSummaryTextNotEqual: 'nu este egal cu',
  filterSummaryStartsWith: 'începe cu',
  filterSummaryEndsWith: 'se termină cu',
  filterSummaryBlank: 'este gol',
  filterSummaryNotBlank: 'nu este gol',
  filterSummaryEquals: '=',
  filterSummaryNotEqual: '!=',
  filterSummaryGreaterThan: '>',
  filterSummaryGreaterThanOrEqual: '>=',
  filterSummaryLessThan: '<',
  filterSummaryLessThanOrEqual: '<=',
  filterSummaryInRange: 'între',
  filterSummaryInRangeValues: '(${variable}, ${variable})',
  filterSummaryTextQuote: '"${variable}"',
  filterSummaryListInactive: 'este (Toate)',
  filterSummaryListSeparator: ', ',
  filterSummaryListShort: 'este (${variable})',
  filterSummaryListLong: 'este (${variable}) și ${variable} mai mult',
  addFilterCard: 'Adaugă filtru',
  agTextColumnFilterDisplayName: 'Filtru simplu',
  agNumberColumnFilterDisplayName: 'Filtru simplu',
  agDateColumnFilterDisplayName: 'Filtru simplu',
  agSetColumnFilterDisplayName: 'Filtru de selecție',
  agMultiColumnFilterDisplayName: 'Filtru combinat',
  addFilterPlaceholder: 'Caută coloane...',

  // Advanced Filter
  advancedFilterContains: 'conține',
  advancedFilterNotContains: 'nu conține',
  advancedFilterTextEquals: 'egal',
  advancedFilterTextNotEqual: 'nu este egal',
  advancedFilterStartsWith: 'începe cu',
  advancedFilterEndsWith: 'se termină cu',
  advancedFilterBlank: 'este gol',
  advancedFilterNotBlank: 'nu este gol',
  advancedFilterEquals: '=',
  advancedFilterNotEqual: '!=',
  advancedFilterGreaterThan: '>',
  advancedFilterGreaterThanOrEqual: '>=',
  advancedFilterLessThan: '<',
  advancedFilterLessThanOrEqual: '<=',
  advancedFilterTrue: 'este adevărat',
  advancedFilterFalse: 'este fals',
  advancedFilterAnd: 'ȘI',
  advancedFilterOr: 'SAU',
  advancedFilterApply: 'Aplică',
  advancedFilterReset: 'Resetare',
  advancedFilterCancel: 'Anulează',
  advancedFilterClear: 'Șterge',
  advancedFilterBuilder: 'Constructor',
  advancedFilterValidationMissingColumn: 'Lipsă coloană',
  advancedFilterValidationMissingOption: 'Lipsă opțiune',
  advancedFilterValidationMissingValue: 'Lipsă valoare',
  advancedFilterValidationInvalidColumn: 'Coloană negăsită',
  advancedFilterValidationInvalidOption: 'Opțiune negăsită',
  advancedFilterValidationMissingQuote: 'Valorii îi lipsesc ghilimelele de încheiere',
  advancedFilterValidationNotANumber: 'Valoarea nu este un număr',
  advancedFilterValidationInvalidDate: 'Valoarea nu este o dată validă',
  advancedFilterValidationMissingCondition: 'Lipsă condiție',
  advancedFilterValidationJoinOperatorMismatch:
    'Operatorii de unire din cadrul unei condiții trebuie să fie aceiași',
  advancedFilterValidationInvalidJoinOperator: 'Operator de unire negăsit',
  advancedFilterValidationMissingEndBracket: 'Lipsă paranteză de încheiere',
  advancedFilterValidationExtraEndBracket: 'Prea multe paranteze de încheiere',
  advancedFilterValidationMessage: 'Expresia are o eroare. ${variable} - ${variable}.',
  advancedFilterValidationMessageAtEnd:
    'Expresia are o eroare. ${variable} la sfârșitul expresiei.',
  advancedFilterBuilderTitle: 'Filtru Avansat',
  advancedFilterBuilderApply: 'Aplică',
  advancedFilterBuilderClear: 'Șterge',
  advancedFilterBuilderReset: 'Resetare',
  advancedFilterBuilderCancel: 'Anulează',
  advancedFilterBuilderAddButtonTooltip: 'Adaugă Filtru sau Grup',
  advancedFilterBuilderRemoveButtonTooltip: 'Elimină',
  advancedFilterBuilderMoveUpButtonTooltip: 'Mută În Sus',
  advancedFilterBuilderMoveDownButtonTooltip: 'Mută În Jos',
  advancedFilterBuilderAddJoin: 'Adaugă Grup',
  advancedFilterBuilderAddCondition: 'Adaugă Filtru',
  advancedFilterBuilderSelectColumn: 'Selectează o coloană',
  advancedFilterBuilderSelectOption: 'Selectează o opțiune',
  advancedFilterBuilderEnterValue: 'Introdu o valoare...',
  advancedFilterBuilderValidationAlreadyApplied: 'Filtrul curent a fost deja aplicat.',
  advancedFilterBuilderValidationIncomplete: 'Nu toate condițiile sunt complete.',
  advancedFilterBuilderValidationSelectColumn: 'Trebuie să selectați o coloană.',
  advancedFilterBuilderValidationSelectOption: 'Trebuie să selectați o opțiune.',
  advancedFilterBuilderValidationEnterValue: 'Trebuie să introduceți o valoare.',

  // Editor Validation Errors
  minDateValidation: 'Data trebuie să fie după ${variable}',
  maxDateValidation: 'Data trebuie să fie înainte de ${variable}',
  maxLengthValidation: 'Trebuie să fie cel mult ${variable} caractere.',
  minValueValidation: 'Trebuie să fie mai mare sau egal cu ${variable}',
  maxValueValidation: 'Trebuie să fie mai mic sau egal cu ${variable}',
  strictMinValueValidation: 'Trebuie să fie mai mare decât ${variable}',
  strictMaxValueValidation: 'Trebuie să fie mai mic decât ${variable}',
  invalidSelectionValidation: 'Selecție invalidă.',

  // Formulas
  invalidFormulaValidation: 'Formulă invalidă.',
  formulaParseInvalidCellReference: 'Referință de celulă invalidă: ${variable}.',
  formulaParseInvalidRangeEndReference: 'Referință de sfârșit de interval invalidă.',
  formulaParseUnterminatedString: 'Șir neterminat.',
  formulaParseUnexpectedCharacter: 'Caracter neașteptat: ${variable}.',
  formulaParseOperatorStackUnderflow: 'Subdepășire a stivei de operatori.',
  formulaParseMissingOperand: "Operand lipsă pentru '${variable}'.",
  formulaParseInternalUnexpectedFrameDuringReduction:
    'Eroare internă: cadru neașteptat în timpul reducerii.',
  formulaParseInternalUnexpectedFrameBeforeOpenParen:
    "Eroare internă: cadru neașteptat înainte de '('.",
  formulaParseMisplacedComma: 'Virgulă plasată greșit.',
  formulaParseCommaOutsideFunctionCall: 'Virgulă în afara unui apel de funcție.',
  formulaParseInternalUnexpectedFrameBeforeCloseParen:
    "Eroare internă: cadru neașteptat înainte de ')'.",
  formulaParseMismatchedParentheses: 'Paranteze necorespunzătoare.',
  formulaParseUnsupportedOperand: 'Operand neacceptat: ${variable}.',
  formulaParseMismatchedParenthesesOrUnfinishedFunctionCall:
    'Paranteze necorespunzătoare sau apel de funcție neterminat.',
  formulaParseInvalidExpression: 'Expresie invalidă.',
  formulaParseFormulasMustBeginWithEquals: 'Formulele trebuie să înceapă cu =.',
  formulaSerializeStringContainsQuote:
    'Șirul conține ghilimele (") pe care tokenizatorul nu le acceptă.',
  formulaSerializeCannotProduceAbsoluteColumnLabelFromId:
    "Nu se poate produce eticheta absolută de COLOANĂ din id-ul '${variable}'.",
  formulaSerializeCannotProduceAbsoluteRowIndexFromId:
    "Nu se poate produce indexul absolut de RÂND din id-ul '${variable}'.",
  formulaSerializeCannotProduceRowIndexFromId:
    "Nu se poate produce indexul de RÂND din id-ul '${variable}'.",
  formulaSerializeCannotMapColumnIdToA1Label:
    "Nu se poate mapa id-ul coloanei '${variable}' la eticheta A1.",
  formulaSerializeCannotParseAbsoluteRowIndex:
    "Nu se poate analiza indexul absolut de rând '${variable}'.",
  formulaSerializeCannotMapRowIdToA1Index:
    "Nu se poate mapa id-ul rândului '${variable}' la indexul A1.",
  formulaEvalRangeNotAllowedInScalarContext: 'Intervalul nu este permis în context scalar.',
  formulaEvalUnknownReferenceToCell: 'Referință necunoscută la celulă.',
  formulaEvalUnsupportedOperation: 'Operație neacceptată ${variable}.',
  formulaEvalInvalidAbsoluteRow: 'Rând absolut invalid.',
  formulaEvalUnrecognisedRowId: 'Id de rând nerecunoscut.',
  formulaEvalInvalidAbsoluteColumn: 'Coloană absolută invalidă.',
  formulaEvalUnrecognisedColumnId: 'Id de coloană nerecunoscut.',
  formulaEvalUnrecognisedRowInRange: 'Rând nerecunoscut în interval.',
  formulaEvalUnrecognisedReferenceToCell: 'Referință la celulă nerecunoscută.',
  formulaEvalIncompleteRangeReference: 'Referință de interval incompletă.',
  formulaFunctionExpectedExactlyArguments: '${variable}: se așteptau exact ${variable} argumente.',
  formulaFunctionExpectedAtMostArguments:
    '${variable}: se așteptau cel mult ${variable} argumente.',
  formulaFunctionExpectedAtLeastArguments:
    '${variable}: se așteptau cel puțin ${variable} argumente.',
  formulaFunctionInvalidCriteriaWildcardsWithComparator:
    'Criteriu invalid: metacaractere cu operator de comparare.',
  formulaFunctionNonNumericArgument: '${variable}: argument nenumeric.',
  formulaFunctionDivisionByZero: '${variable}: împărțire la zero.',
  formulaFunctionCannotCombineDatesWithBigInt: '${variable}: nu se pot combina datele cu BigInt.',
  formulaFunctionRequiresAtLeastOneNumericValue:
    '${variable}: necesită cel puțin o valoare numerică.',
  formulaFunctionRequiresAtLeastOneValue: '${variable}: necesită cel puțin o valoare.',
  formulaFunctionAllValuesMustBeNumbers: '${variable}: toate valorile trebuie să fie numere.',
  formulaFunctionArgumentMustBeRange:
    '${variable}: argumentul ${variable} trebuie să fie un interval.',
  formulaFunctionArgumentMustBeValue:
    '${variable}: argumentul ${variable} trebuie să fie o valoare.',
  formulaFunctionRangesHaveDifferentSizes: '${variable}: intervalele au dimensiuni diferite.',
  formulaFunctionValuesMustBeNumeric: '${variable}: valorile trebuie să fie numerice.',
  formulaFunctionValuesMustBeIntegers: '${variable}: valorile trebuie să fie numere întregi.',
  formulaFunctionUnsupportedValueType: '${variable}: tip de valoare neacceptat.',
  formulaFunctionDivNonNumericArgument: 'DIV: argument nenumeric.',
  formulaFunctionDivDivisionByZero: 'DIV: împărțire la zero.',
  formulaFunctionSumCannotCombineDatesWithBigInt: 'SUM: nu se pot combina datele cu BigInt.',
  formulaFunctionSumRequiresAtLeastOneNumericValue: 'SUM: necesită cel puțin o valoare numerică.',
  formulaFunctionAvgRequiresAtLeastOneValue: 'AVG: necesită cel puțin o valoare.',
  formulaFunctionMedianAllValuesMustBeNumbers: 'MEDIAN: toate valorile trebuie să fie numere.',
  formulaFunctionMedianRequiresAtLeastOneValue: 'MEDIAN: necesită cel puțin o valoare.',
  formulaFunctionSumifFirstArgumentMustBeRange:
    'SUMIF: primul argument trebuie să fie un interval.',
  formulaFunctionSumifSecondArgumentMustBeValue:
    'SUMIF: al doilea argument trebuie să fie o valoare (criteriu).',
  formulaFunctionSumifThirdArgumentMustBeRange:
    'SUMIF: al treilea argument trebuie să fie un interval (sum_range).',
  formulaFunctionSumifRangesHaveDifferentSizes: 'SUMIF: intervalele au dimensiuni diferite.',
  formulaFunctionCountifFirstArgumentMustBeRange:
    'COUNTIF: primul argument trebuie să fie un interval.',
  formulaFunctionCountifSecondArgumentMustBeValue:
    'COUNTIF: al doilea argument trebuie să fie o valoare (criteriu).',
  formulaFunctionConcatUnsupportedValueType: 'CONCAT: tip de valoare neacceptat.',
  formulaFunctionMinRequiresAtLeastOneValue: 'MIN: necesită cel puțin o valoare.',
  formulaFunctionMaxRequiresAtLeastOneValue: 'MAX: necesită cel puțin o valoare.',
  formulaFunctionPercentNonNumericArgument: 'PERCENT: argument nenumeric.',
  formulaFunctionPowerNonNumericArgument: 'POWER: argument nenumeric.',
  formulaServiceCircularReference: 'Referință circulară.',
  formulaServiceExpectedParsableFormula: 'Se aștepta o formulă care poate fi analizată.',
  formulaServiceInternalSchedulingError: 'Eroare internă de planificare.',
  tooltipValidationErrorSeparator: '. ',

  // Side Bar
  columns: 'Coloane',
  filters: 'Filtre',

  // columns tool panel
  pivotMode: 'Mod Pivot',
  groups: 'Grupuri de Rânduri',
  rowGroupColumnsEmptyMessage: 'Trageți aici pentru a seta grupuri de rânduri',
  values: 'Valori',
  valueColumnsEmptyMessage: 'Trageți aici pentru a agrega',
  pivots: 'Etichete de Coloane',
  pivotColumnsEmptyMessage: 'Trageți aici pentru a seta etichete de coloane',

  // Header of the Default Group Column
  group: 'Grup',

  // Row Drag
  rowDragRow: 'rând',
  rowDragRows: 'rânduri',

  // Other
  loadingOoo: 'Se încarcă...',
  loadingError: 'EROARE',
  noRowsToShow: 'Niciun rând de afișat',
  noMatchingRows: 'Niciun rând nu se potrivește',
  exportingOoo: 'Se exportă...',
  enabled: 'Activat',

  // Menu
  pinColumn: 'Fixează Coloana',
  pinLeft: 'Fixează la Stânga',
  pinRight: 'Fixează la Dreapta',
  noPin: 'Nu Fixa',
  pinRow: 'Fixează rândul',
  pinTop: 'Fixează în partea de sus',
  pinBottom: 'Fixează în partea de jos',
  unpinRow: 'Anulează fixarea rândului',
  valueAggregation: 'Agregare Valori',
  noAggregation: 'Niciuna',
  autosizeThisColumn: 'Redimensionează automat această coloană',
  autosizeAllColumns: 'Redimensionează automat toate coloanele',
  groupBy: 'Grupează după ${variable}',
  ungroupBy: 'Degrupează după ${variable}',
  ungroupAll: 'Degrupează tot',
  addToValues: 'Adaugă ${variable} la valori',
  removeFromValues: 'Elimină ${variable} din valori',
  addToLabels: 'Adaugă ${variable} la etichete',
  removeFromLabels: 'Elimină ${variable} din etichete',
  resetColumns: 'Resetează coloanele',
  expandAll: 'Extinde toate grupurile de rânduri',
  collapseAll: 'Restrânge toate grupurile de rânduri',
  copy: 'Copiază',
  ctrlC: 'Ctrl+C',
  ctrlX: 'Ctrl+X',
  copyWithHeaders: 'Copiază cu Antete',
  copyWithGroupHeaders: 'Copiază cu Antete de Grup',
  cut: 'Taie',
  paste: 'Lipește',
  ctrlV: 'Ctrl+V',
  export: 'Exportă',
  csvExport: 'Exportă CSV',
  excelExport: 'Exportă Excel',
  columnFilter: 'Filtru de Coloană',
  columnChooser: 'Alege Coloane',
  chooseColumns: 'Alege Coloane',
  sortAscending: 'Sortare Ascendentă',
  sortDescending: 'Sortare Descendentă',
  sortAbsoluteAscending: 'Sortează în ordine ascendentă absolută',
  sortAbsoluteDescending: 'Sortează în ordine descendentă absolută',
  sortUnSort: 'Șterge Sortarea',
  shiftF2: 'Shift+F2',
  toolbarFind: 'Caută',
  toolbarFindPreviousMatch: 'Potrivire Anterioară',
  toolbarFindNextMatch: 'Potrivire Următoare',
  toolbarQuickFilter: 'Filtru',
  toolbarMenu: 'Meniu',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sumă',
  first: 'Primul',
  last: 'Ultimul',
  min: 'Minim',
  max: 'Maxim',
  none: 'Niciunul',
  count: 'Numărătoare',
  avg: 'Medie',
  filteredRows: 'Filtrate',
  selectedRows: 'Selectate',
  totalRows: 'Total Rânduri',
  totalAndFilteredRows: 'Rânduri',
  more: 'Mai mult',
  to: 'la',
  of: 'din',
  page: 'Pagină',
  pageLastRowUnknown: '?',
  nextPage: 'Pagina Următoare',
  lastPage: 'Ultima Pagină',
  firstPage: 'Prima Pagină',
  previousPage: 'Pagina Anterioară',
  pageSizeSelectorLabel: 'Mărime Pagină:',
  footerTotal: 'Total',
  statusBarLastRowUnknown: '?',
  scrollColumnIntoView: 'Derulează ${variable} în vizualizare',

  // Pivoting
  pivotColumnGroupTotals: 'Total',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart și Modul Pivot',
  pivotChart: 'Pivot Chart',
  chartRange: 'Interval Grafic',
  columnChart: 'Coloană',
  groupedColumn: 'Grupat',
  stackedColumn: 'Stivuit',
  normalizedColumn: '100% Stivuit',
  barChart: 'Bară',
  groupedBar: 'Grupat',
  stackedBar: 'Stivuit',
  normalizedBar: '100% Stivuit',
  pieChart: 'Plăcintă',
  pie: 'Plăcintă',
  donut: 'Gogoașă',
  lineChart: 'Linie',
  stackedLine: 'Stivuit',
  normalizedLine: '100% Stivuit',
  xyChart: 'X Y (Puncte dispersate)',
  scatter: 'Puncte dispersate',
  bubble: 'Bule',
  areaChart: 'Zonă',
  area: 'Zonă',
  stackedArea: 'Stivuit',
  normalizedArea: '100% Stivuit',
  histogramChart: 'Histogramă',
  polarChart: 'Polar',
  radarLine: 'Linie Radar',
  radarArea: 'Zonă Radar',
  nightingale: 'Nightingale',
  radialColumn: 'Coloană Radială',
  radialBar: 'Bară Radială',
  statisticalChart: 'Statistic',
  boxPlot: 'Grafic Box',
  rangeBar: 'Bară Interval',
  rangeArea: 'Zonă Interval',
  hierarchicalChart: 'Ierarhic',
  treemap: 'Hartă Arbore',
  sunburst: 'Explozie Solară',
  specializedChart: 'Specializat',
  waterfall: 'Cascadă',
  heatmap: 'Hartă Termică',
  combinationChart: 'Combinată',
  columnLineCombo: 'Coloană și Linie',
  AreaColumnCombo: 'Zonă și Coloană',

  // Charts
  pivotChartTitle: 'Grafic Pivot',
  rangeChartTitle: 'Grafic Interval',
  settings: 'Setări',
  data: 'Date',
  format: 'Format',
  categories: 'Categorii',
  defaultCategory: '(Niciunul)',
  series: 'Serii',
  switchCategorySeries: 'Schimbare Categorie / Serii',
  categoryValues: 'Valori Categorie',
  seriesLabels: 'Etichete Serii',
  aggregate: 'Agregat',
  xyValues: 'Valori X Y',
  paired: 'Mod Pereche',
  axis: 'Axă',
  xAxis: 'Axă Orizontală',
  yAxis: 'Axă Verticală',
  polarAxis: 'Axă Polară',
  radiusAxis: 'Axă Radius',
  navigator: 'Navigator',
  zoom: 'Zoom',
  animation: 'Animație',
  crosshair: 'Reticul',
  color: 'Culoare',
  thickness: 'Grosime',
  preferredLength: 'Lungime preferată',
  xType: 'Tip X',
  axisType: 'Tip Axă',
  automatic: 'Automat',
  category: 'Categorie',
  // eslint-disable-next-line id-denylist
  number: 'Număr',
  time: 'Timp',
  timeFormat: 'Format Timp',
  autoRotate: 'Rotație automată',
  labelRotation: 'Rotație',
  circle: 'Cerc',
  polygon: 'Poligon',
  square: 'Pătrat',
  cross: 'Cruce',
  diamond: 'Diamant',
  plus: 'Plus',
  triangle: 'Triunghi',
  heart: 'Inimă',
  orientation: 'Orientare',
  fixed: 'Fix',
  parallel: 'Paralel',
  perpendicular: 'Perpendicular',
  radiusAxisPosition: 'Poziție',
  ticks: 'Marcaje',
  gridLines: 'Linii Grilă',
  width: 'Lățime',
  height: 'Înălțime',
  length: 'Lungime',
  padding: 'Padding',
  spacing: 'Spațiere',
  chartStyle: 'Stil Grafic',
  title: 'Titlu',
  chartTitles: 'Titluri',
  chartTitle: 'Titlu Grafic',
  chartSubtitle: 'Subtitlu',
  horizontalAxisTitle: 'Titlu Axă Orizontală',
  verticalAxisTitle: 'Titlu Axă Verticală',
  polarAxisTitle: 'Titlu Axă Polară',
  titlePlaceholder: 'Titlu Grafic',
  background: 'Fundal',
  font: 'Font',
  weight: 'Greutate',
  top: 'Deasupra',
  right: 'Dreapta',
  bottom: 'Dedesubt',
  left: 'Stânga',
  labels: 'Etichete',
  calloutLabels: 'Etichete Apel',
  sectorLabels: 'Etichete Sector',
  positionRatio: 'Raport Poziție',
  size: 'Mărime',
  shape: 'Formă',
  minSize: 'Mărime Minimă',
  maxSize: 'Mărime Maximă',
  legend: 'Legendă',
  position: 'Poziție',
  markerSize: 'Mărime Marcaj',
  markerStroke: 'Tușe Marcaj',
  markerPadding: 'Padding Marcaj',
  itemSpacing: 'Spațiere Elemente',
  itemPaddingX: 'Padding Element X',
  itemPaddingY: 'Padding Element Y',
  layoutHorizontalSpacing: 'Spațiere Orizontală',
  layoutVerticalSpacing: 'Spațiere Verticală',
  strokeWidth: 'Grosime Linie',
  offset: 'Offset',
  offsets: 'Offset-uri',
  tooltips: 'Tooltip-uri',
  callout: 'Apel',
  markers: 'Marcaje',
  shadow: 'Umbră',
  blur: 'Estompare',
  xOffset: 'Offset X',
  yOffset: 'Offset Y',
  lineWidth: 'Grosime Linie',
  lineDash: 'Linie Punctată',
  lineDashOffset: 'Offset Linie Punctată',
  scrollingZoom: 'Defilare',
  scrollingStep: 'Pas Defilare',
  selectingZoom: 'Selectare',
  durationMillis: 'Durată (ms)',
  crosshairLabel: 'Etichetă',
  crosshairSnap: 'Fixare pe Nod',
  normal: 'Normal',
  bold: 'Aldin',
  italic: 'Italic',
  boldItalic: 'Aldin Italic',
  predefined: 'Predefinit',
  fillOpacity: 'Opacitate Umplere',
  strokeColor: 'Culoare Linie',
  strokeOpacity: 'Opacitate Linie',
  miniChart: 'Mini-Grafic',
  histogramBinCount: 'Număr Benzi',
  connectorLine: 'Linie Conectare',
  seriesItems: 'Elemente Serii',
  seriesItemType: 'Tip Element',
  seriesItemPositive: 'Pozitiv',
  seriesItemNegative: 'Negativ',
  seriesItemLabels: 'Etichete Elemente',
  columnGroup: 'Coloană',
  barGroup: 'Bară',
  pieGroup: 'Plăcintă',
  lineGroup: 'Linie',
  scatterGroup: 'X Y (Dispersie)',
  areaGroup: 'Zonă',
  polarGroup: 'Polar',
  statisticalGroup: 'Statistic',
  hierarchicalGroup: 'Ierarhic',
  specializedGroup: 'Specializat',
  combinationGroup: 'Combinație',
  groupedColumnTooltip: 'Grupat',
  stackedColumnTooltip: 'Stivuit',
  normalizedColumnTooltip: '100% Stivuit',
  groupedBarTooltip: 'Grupat',
  stackedBarTooltip: 'Stivuit',
  normalizedBarTooltip: '100% Stivuit',
  pieTooltip: 'Plăcintă',
  donutTooltip: 'Gogoașă',
  lineTooltip: 'Linie',
  stackedLineTooltip: 'Stivuit',
  normalizedLineTooltip: '100% Stivuit',
  groupedAreaTooltip: 'Grupat',
  stackedAreaTooltip: 'Stivuit',
  normalizedAreaTooltip: '100% Stivuit',
  scatterTooltip: 'Dispersie',
  bubbleTooltip: 'Bulă',
  histogramTooltip: 'Histogramă',
  radialColumnTooltip: 'Coloană Radială',
  radialBarTooltip: 'Bară Radială',
  radarLineTooltip: 'Linie Radar',
  radarAreaTooltip: 'Zonă Radar',
  nightingaleTooltip: 'Nightingale',
  rangeBarTooltip: 'Bară Interval',
  rangeAreaTooltip: 'Zonă Interval',
  boxPlotTooltip: 'Box Plot',
  treemapTooltip: 'Hartă Arbore',
  sunburstTooltip: 'Sunburst',
  waterfallTooltip: 'Cascadă',
  heatmapTooltip: 'Hartă Termică',
  columnLineComboTooltip: 'Coloană & Linie',
  areaColumnComboTooltip: 'Zonă & Coloană',
  customComboTooltip: 'Combinație Personalizată',
  innerRadius: 'Raza Interioară',
  startAngle: 'Unghi de Start',
  endAngle: 'Unghi de Sfârșit',
  reverseDirection: 'Direcție Inversă',
  groupPadding: 'Padding Grup',
  seriesPadding: 'Padding Serii',
  tile: 'Placă',
  whisker: 'Mustață',
  cap: 'Capac',
  capLengthRatio: 'Raport Lungime Capac',
  labelPlacement: 'Plasament Etichetă',
  inside: 'În Interior',
  outside: 'În Exterior',
  noDataToChart: 'Nu sunt date disponibile pentru grafic.',
  pivotChartRequiresPivotMode: 'Graficul Pivot necesită activarea Modului Pivot.',
  chartSettingsToolbarTooltip: 'Meniu',
  chartLinkToolbarTooltip: 'Legat la Grila',
  chartUnlinkToolbarTooltip: 'Nelegat de Grilă',
  chartDownloadToolbarTooltip: 'Descărcare Grafic',
  chartMenuToolbarTooltip: 'Meniu',
  chartEdit: 'Editare Grafic',
  chartAdvancedSettings: 'Setări Avansate',
  chartLink: 'Legare la Grilă',
  chartUnlink: 'Dezlegare de Grilă',
  chartDownload: 'Descărcare Grafic',
  histogramFrequency: 'Frecvență',
  seriesChartType: 'Tip Grafic Serii',
  seriesType: 'Tip Serii',
  secondaryAxis: 'Axă Secundară',
  seriesAdd: 'Adăugați o serie',
  categoryAdd: 'Adăugați o categorie',
  bar: 'Bară',
  column: 'Coloană',
  histogram: 'Histogramă',
  advancedSettings: 'Setări Avansate',
  direction: 'Direcție',
  horizontal: 'Orizontal',
  vertical: 'Vertical',
  seriesGroupType: 'Tip Grup',
  groupedSeriesGroupType: 'Grupat',
  stackedSeriesGroupType: 'Stivuit',
  normalizedSeriesGroupType: '100% Stivuit',
  legendEnabled: 'Activat',
  invalidColor: 'Valoarea culorii este invalidă',
  groupedColumnFull: 'Coloană Grupată',
  stackedColumnFull: 'Coloană Stivuită',
  normalizedColumnFull: 'Coloană 100% Stivuită',
  groupedBarFull: 'Bară Grupată',
  stackedBarFull: 'Bară Stivuită',
  normalizedBarFull: 'Bară 100% Stivuită',
  stackedAreaFull: 'Zonă Stivuită',
  normalizedAreaFull: 'Zonă 100% Stivuită',
  customCombo: 'Combinație Personalizată',
  funnel: 'Pâlnie',
  coneFunnel: 'Pâlnie Con',
  pyramid: 'Piramidă',
  funnelGroup: 'Grup Pâlnie',
  funnelTooltip: 'Pâlnie',
  coneFunnelTooltip: 'Pâlnie Con',
  pyramidTooltip: 'Piramidă',
  dropOff: 'Scădere',
  stageLabels: 'Etichete Etapă',
  reverse: 'Invers',
  tooltipMode: 'Mod Tooltip',
  tooltipModeSingle: 'Unic',
  tooltipModeShared: 'Partajat',
  tooltipModeCompact: 'Compact',

  // ARIA
  ariaAdvancedFilterBuilderItem: '${variable}. Nivel ${variable}. Apăsați ENTER pentru a edita.',
  ariaAdvancedFilterBuilderItemValidation:
    '${variable}. Nivel ${variable}. ${variable} Apăsați ENTER pentru a edita.',
  ariaAdvancedFilterBuilderList: 'Lista Constructorului de Filtre Avansate',
  ariaAdvancedFilterBuilderFilterItem: 'Condiție de Filtrare',
  ariaAdvancedFilterBuilderGroupItem: 'Grup de Filtre',
  ariaAdvancedFilterBuilderColumn: 'Coloană',
  ariaAdvancedFilterBuilderOption: 'Opțiune',
  ariaAdvancedFilterBuilderValueP: 'Valoare',
  ariaAdvancedFilterBuilderJoinOperator: 'Operator de Îmbinare',
  ariaAdvancedFilterInput: 'Intrare Filtru Avansat',
  ariaChecked: 'bifat',
  ariaColumn: 'Coloană',
  ariaColumnGroup: 'Grup de Coloane',
  ariaFilterActive: 'Filtru activ',
  ariaColumnFiltered: 'Coloană Filtrată',
  ariaColumnSelectAll: 'Comută vizibilitatea tuturor coloanelor',
  ariaDateFilterInput: 'Intrare Filtru de Dată',
  ariaDefaultListName: 'Listă',
  ariaFilterColumnsInput: 'Intrare Filtrare Coloane',
  ariaFilterFromValue: 'Filtrează de la valoare',
  ariaFilterInput: 'Intrare Filtru',
  ariaFilterList: 'Listă de Filtre',
  ariaFilterToValue: 'Filtrează până la valoare',
  ariaFilterValue: 'Valoare Filtrată',
  ariaFilterMenuOpen: 'Deschide Meniul Filtrului',
  ariaFilteringOperator: 'Operator de Filtrare',
  ariaHidden: 'ascuns',
  ariaIndeterminate: 'nedeterminat',
  ariaInputEditor: 'Editor Intrare',
  ariaMenuColumn: 'Apăsați ALT în jos pentru a deschide meniul coloanei',
  ariaFilterColumn: 'Apăsați CTRL ENTER pentru a deschide filtrul',
  ariaRowDeselect: 'Apăsați SPACE pentru a deselecta acest rând',
  ariaHeaderSelection: 'Coloană cu selecție antet',
  ariaSelectAllCells: 'Apăsați Space sau Enter pentru a selecta toate celulele',
  ariaSelectAllRowCells: 'Apăsați Enter pentru a selecta toate celulele din acest rând',
  ariaColumnCellSelection:
    'Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din această coloană',
  ariaColumnGroupCellSelection:
    'Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane',
  ariaColumnGroupExpansion: 'Apăsați ENTER pentru a extinde sau restrânge acest grup de coloane',
  ariaColumnGroupCellSelectionAndExpansion:
    'Apăsați Enter pentru a comuta selecția tuturor celulelor vizibile din acest grup de coloane. Apăsați ALT ENTER pentru a extinde sau restrânge acest grup de coloane',
  ariaRowSelectAll: 'Apăsați Space pentru a comuta selecția tuturor rândurilor',
  ariaRowToggleSelection: 'Apăsați Space pentru a comuta selecția rândului',
  ariaRowSelect: 'Apăsați SPACE pentru a selecta acest rând',
  ariaRowSelectionDisabled: 'Selecția rândului este dezactivată pentru acest rând',
  ariaSearch: 'Căutare',
  ariaSortableColumn: 'Apăsați ENTER pentru a sorta',
  ariaSortableColumnWithCellSelection: 'Apăsați ALT ENTER pentru a sorta',
  ariaToggleVisibility: 'Apăsați SPACE pentru a comuta vizibilitatea',
  ariaToggleCellValue: 'Apăsați SPACE pentru a comuta valoarea celulei',
  ariaUnchecked: 'nebifat',
  ariaVisible: 'vizibil',
  ariaSearchFilterValues: 'Caută valori ale filtrului',
  ariaPageSizeSelectorLabel: 'Dimensiunea Paginii',
  ariaChartMenuClose: 'Închide meniul de editare a graficului',
  ariaChartSelected: 'Selectat',
  ariaSparklineChartDescription:
    'Sparkline - ${chartType} afișează ${count} valori între ${min} și ${max}. Începe la ${start} și se termină la ${end}.',
  ariaSparklineChartDescriptionSingleValue:
    'Sparkline - ${chartType} afișează 1 valoare: ${value}.',
  ariaSparklineChartDescriptionEmpty: 'Sparkline - ${chartType} fără valori.',
  ariaSkeletonCellLoadingFailed: 'Încărcarea rândului a eșuat',
  ariaSkeletonCellLoading: 'Datele rândului se încarcă',
  ariaDeferSkeletonCellLoading: 'Celula se încarcă',

  // ARIA for Batch Edit
  ariaPendingChange: 'Modificare în așteptare',

  // ARIA Labels for Drop Zones
  ariaRowGroupDropZonePanelLabel: 'Grupuri de rânduri',
  ariaValuesDropZonePanelLabel: 'Valori',
  ariaPivotDropZonePanelLabel: 'Etichete de coloană',
  ariaDropZoneColumnComponentDescription: 'Apăsați DELETE pentru a elimina',
  ariaDropZoneColumnValueItemDescription: 'Apăsați ENTER pentru a schimba tipul de agregare',
  ariaDropZoneColumnGroupItemDescription: 'Apăsați ENTER pentru a sorta',

  // used for aggregate drop zone, format: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
  ariaDropZoneColumnComponentAggFuncSeparator: ' din ',
  ariaDropZoneColumnComponentSortAscending: 'crescător',
  ariaDropZoneColumnComponentSortDescending: 'descrescător',
  ariaDropZoneColumnComponentSortAbsoluteAscending: 'ascendent absolut',
  ariaDropZoneColumnComponentSortAbsoluteDescending: 'descendent absolut',
  ariaLabelDialog: 'Dialog',
  ariaLabelColumnMenu: 'Meniu Coloană',
  ariaLabelColumnFilter: 'Filtru Coloană',
  ariaLabelSelectField: 'Selectează Câmp',

  // Cell Editor
  ariaValidationErrorPrefix: 'Validare editor de celule',
  ariaLabelLoadingContextMenu: 'Încărcare Meniu Contextual',

  // aria labels for rich select
  ariaLabelRichSelectField: 'Câmp Selectare Avansată',
  ariaLabelRichSelectToggleSelection: 'Apăsați SPACE pentru a comuta selecția',
  ariaLabelRichSelectDeselectAllItems: 'Apăsați DELETE pentru a deselecta toate elementele',
  ariaLabelRichSelectDeleteSelection: 'Apăsați DELETE pentru a deselecta elementul',
  ariaLabelTooltip: 'Sugestie',
  ariaLabelContextMenu: 'Meniu Contextual',
  ariaLabelSubMenu: 'Submeniu',
  ariaLabelAggregationFunction: 'Funcția de Agregare',
  ariaLabelAdvancedFilterAutocomplete: 'Autocompletare Filtru Avansat',
  ariaLabelAdvancedFilterBuilderAddField: 'Constructor Filtru Avansat - Adăugare Câmp',
  ariaLabelAdvancedFilterBuilderColumnSelectField:
    'Constructor Filtru Avansat - Selectare Coloană Câmp',
  ariaLabelAdvancedFilterBuilderOptionSelectField:
    'Constructor Filtru Avansat - Selectare Opțiune Câmp',
  ariaLabelAdvancedFilterBuilderJoinSelectField:
    'Constructor Filtru Avansat - Selectare Operator De Unire Câmp',

  // ARIA Labels for the Side Bar
  ariaColumnPanelList: 'Listă de coloane',
  ariaFilterPanelList: 'Listă de filtre',

  // ARIA labels for new Filters Tool Panel
  ariaLabelAddFilterField: 'Adaugă Câmp de Filtrare',
  ariaLabelFilterCardDelete: 'Șterge Filtrul',
  ariaLabelFilterCardHasEdits: 'Are Modificări',
  ariaHasNote: 'Această celulă are o notă.',

  // Number Format (Status Bar, Pagination Panel)
  thousandSeparator: ',',
  decimalSeparator: '.',

  // Data types
  true: 'Adevărat',
  false: 'Fals',
  invalidDate: 'Dată invalidă',
  invalidNumber: 'Număr invalid',
  invalidBigInt: 'BigInt invalid',
  january: 'Ianuarie',
  february: 'Februarie',
  march: 'Martie',
  april: 'Aprilie',
  may: 'Mai',
  june: 'Iunie',
  july: 'Iulie',
  august: 'August',
  september: 'Septembrie',
  october: 'Octombrie',
  november: 'Noiembrie',
  december: 'Decembrie',

  // Date-time parts
  year: 'An',
  quarter: 'Trimestru',
  month: 'Lună',
  day: 'Zi',
  hour: 'Oră',
  minute: 'Minut',
  second: 'Secundă',

  // Time formats
  timeFormatSlashesDDMMYYYY: 'ZZ/LL/AAAA',
  timeFormatSlashesMMDDYYYY: 'LL/ZZ/AAAA',
  timeFormatSlashesDDMMYY: 'ZZ/LL/AA',
  timeFormatSlashesMMDDYY: 'LL/ZZ/AA',
  timeFormatDotsDDMYY: 'ZZ.L.AA',
  timeFormatDotsMDDYY: 'L.ZZ.AA',
  timeFormatDashesYYYYMMDD: 'AAAA-LL-ZZ',
  timeFormatSpacesDDMMMMYYYY: 'ZZ LLLL AAAA',
  timeFormatHHMMSS: 'OO:MM:SS',
  timeFormatHHMMSSAmPm: 'OO:MM:SS AM/PM',

  // Notes
  note: 'Notă celulă',
  addNote: 'Adaugă notă',
  viewNote: 'Vizualizează nota',
  editNote: 'Editează nota',
  deleteNote: 'Elimină nota',
  notePlaceholder: 'Adaugă o notă...',
}
